// extracted by mini-css-extract-plugin
export default {"icon":"Individual_icon__dptw+","placeHolderShimmer":"Individual_placeHolderShimmer__ud5Zu"};